export { AnimatedFooter, default } from './AnimatedFooter';